
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { firestore } from "@/config/firebase";
import { loaderStart, loaderDone } from "@/services/Loader";
import { showMessage } from "@/services/MessageService";
import i18n from "@/i18n";
import html2PDF from "jspdf-html2canvas";

export default defineComponent({
  setup() {
    const eventData = computed(() => store.getters["user/eventData"]);
    const route = useRoute();
    const store = useStore();
    const participantData = computed(() => {
      return store.getters["user/participantData"];
    });
    const qrCode = ref("");
    const profileImage = ref("");
    const ticketType = ref("");

    const getUserQRCode = async (eventID, uid) => {
      const userRef = await firestore("events")
        .doc(eventID)
        .collection("participants")
        .doc(uid)
        .get();
      qrCode.value = userRef.data()?.qrCode;
      profileImage.value = userRef.data()?.profileImage;
    };

    const DownloadPDF = () => {
      let page = document.getElementById("qrID");
      html2PDF(page, {
        jsPDF: {
          format: "a4",
        },
        imageType: "image/jpeg",
        html2canvas: {
          dpi: 300,
          letterRendering: true,
          useCORS: true,
          width: 750,
          height: 700,
        },
        output: "QR_IDEvent.pdf",
      });
    };

    const queryTicketType = async (eventID, ticketID) => {
      const ticketRef = await firestore("events")
        .doc(eventID)
        .collection("tickets")
        .doc(ticketID)
        .get();
      return ticketRef.data()!.name;
    };

    onMounted(async () => {
      try {
        loaderStart();
        await getUserQRCode(route.params.eventID, participantData.value.uid);
        ticketType.value = await queryTicketType(
          route.params.eventID,
          participantData.value.ticketType
        );
        loaderDone();
      } catch {
        loaderDone();
        showMessage({
          title: i18n.global.t("event-id-qr.error.title"),
          message: i18n.global.t("event-id-qr.error.message"),
          type: "error",
        });
      }
    });
    return {
      eventData,
      qrCode,
      profileImage,
      ticketType,
      participantData,
      DownloadPDF,
      getUserQRCode,
      queryTicketType,
    };
  },
});
